const headerNavbar = {
  'headerNavBar-navLink1': 'About us',
  'headerNavBar-navLink2': 'Our offer',
  'headerNavBar-navLink4': 'Catering',
  'headerNavBar-navLink5': 'Locations',
  'headerNavBar-navLink6': 'Online-shop',
  'headerNavBar-navLink7': 'Partners',
  'headerNavBar-navLink8': 'Admin'
};

export default headerNavbar;
